<script lang="ts">
	import DefaultButton from '../../../../basic/buttons/DefaultButton.svelte';
	import DefaultNumberInput from '../../../../basic/input/DefaultNumberInput.svelte';
	import DefaultTextInput from '../../../../basic/input/DefaultTextInput.svelte';
	import InputLabel from '../../../../basic/input/InputLabel.svelte';
	import Modal from '../../../../basic/modal/Modal.svelte';
	import ModalHeader from '../../../../basic/modal/ModalHeader.svelte';
	import { addNotification } from '../../../../notification/Notificationstore';
	import { handleStoreError } from '../../../../stores/GeneralStore';
	import {
		type SettingDocumentNameGeneratorStore
	} from '../../../../stores/SettingDocumentNameGeneratorsStore.svelte';
	import type {
		CreateSettingDocumentNameGenerator
	} from '../../../../types/BasicTypes';
	import { _ } from 'svelte-i18n';

	interface Props {
		store: SettingDocumentNameGeneratorStore;
		onModalClose: () => void;
	}

	let { store, onModalClose }: Props = $props();

	const creationObject: CreateSettingDocumentNameGenerator = {
		defaultName: '',
		startingNumber: 0,
		minNumberLength: 5,
		pattern: '{t}_{yyyy}_{nr}'
	};

	async function createSettingDocumentNameGenerator() {
		if (creationObject.defaultName ? creationObject.defaultName.length <= 2 : true) {
			//Inform the user that we need a min length
			addNotification({
				type: 'info',
				message: $_('settings.basic.document_name_generators.lbl_name_length')
			});
			return;
		}

		try {
			//Start to create the resource.
			await store.createSettingDocumentNameGeneratorStore(creationObject);

			//Hide the modal again.
			onModalClose();
		} catch (err) {
			handleStoreError('settings.basic.document_name_generators.err_create', err);
		}
	}
</script>

<Modal {onModalClose} onModalEnter={createSettingDocumentNameGenerator}>
	{#snippet header()}
		<ModalHeader
			
			text={$_('settings.basic.document_name_generators.lbl_create_header')}
		/>
	{/snippet}
	{#snippet content()}
		<div  class="grid gap-2">
			<!--Name-->
			<InputLabel label={$_('settings.basic.document_name_generators.lbl_name')} />
			<DefaultTextInput propertyName="" bind:value={creationObject.defaultName} />
			<!--Starting number-->
			<InputLabel label={$_('settings.basic.document_name_generators.lbl_starting_number')} />
			<DefaultNumberInput
				propertyName=""
				min={0}
				max={1000000}
				bind:value={creationObject.startingNumber}
			/>
			<!--Minimal number length-->
			<InputLabel label={$_('settings.basic.document_name_generators.lbl_min_length')} />
			<DefaultNumberInput
				propertyName=""
				min={0}
				max={8}
				bind:value={creationObject.minNumberLength}
			/>
			<p class="text-sm">
				*{creationObject.startingNumber.toString().padStart(creationObject.minNumberLength, '0')}
			</p>
			<!--Pattern-->
			<InputLabel label={$_('settings.basic.document_name_generators.lbl_pattern')} />
			<DefaultTextInput propertyName="" bind:value={creationObject.pattern} />
			<p class="text-sm">
				*{$_('settings.basic.document_name_generators.lbl_pattern_description')}
			</p>
		</div>
	{/snippet}

	{#snippet footer()}
		<div  class="flex justify-end gap-4">
			<DefaultButton
				secondary={true}
				text={$_('general.bt_close')}
				onClick={() => {
					onModalClose();
				}}
			/>
			<DefaultButton text={$_('general.lbl_create')} onClick={createSettingDocumentNameGenerator} />
		</div>
	{/snippet}
</Modal>
